var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-wrapper"},[_c('InfoList',{attrs:{"data":_vm.newsList,"visited":_vm.visitedNews,"props":{ time: 'pubDate' },"busy":_vm.busy},on:{"load":_vm.getNewsList,"to":_vm.goPage}}),_c('LoadMoreButton',{attrs:{"finished":_vm.finished,"loading":_vm.loading},on:{"click":_vm.getNewsList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }